module.exports = __webpack_public_path__ + "static/shintavr-3ecc9a64ff5103f02f3de71e02329a8c.svg";